import type { Client } from "../paycode/client";

export interface Customer {
  customer_name: string;
  customer_lastname: string;
  customer_phone: string;
  customer_email: string;
}

export const serializeCustomer = (client: Client): Customer => ({
  customer_name: client.name || "",
  customer_lastname: `${client.paternalSurname} ${client.maternalSurname}`,
  customer_phone: client.phone || "",
  customer_email: client.email || "",
});
